const FromArrEditor = [

	{
		key: 'Year',
		modelvalue: undefined,
		title: "年度：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 60,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
	}, {
		key: 'InvClass',
		modelvalue: undefined,
		title: "产品线：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 60,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
	}, {
		key: 'LEVEL3',
		modelvalue: undefined,
		title: "Level3：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 210,
		height: 32,
		disabled: true,
		marginLeft: 60,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
	},
	{
		key: 'AreaMan',
		title: "小区经理：",
		// inputtype: "input",
		inputtype: "selectSingle",
		modelvalue: '',
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: true,
		marginLeft: 32,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
		loading: false,
		remoteMethod: 'AuthorizedDealer',
		event: 'AuthorizedDealerChange'
	},
	{
		key: 'MoneyQuota',
		modelValue: undefined,
		title: "年度金额BP：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 28,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	}
];
export default FromArrEditor;
